<app-navbar></app-navbar>
<div
  class="card"
  style="
    padding: 20px; //background-image: url('assets/img/school/bg.png');
    background-color: #005a63;
    background-size: 100px;
    background-attachment: fixed;
  "
>
  <h2 style=" color: white;text-align: center; margin-bottom: 10px">
    Physio Therapy Section
  </h2>
  <div>
    <img
      class="img-fluid"
      style="height: 500px; width: 100%; object-fit: cover; border-radius: 10px"
      src="assets/img/school/news/7.jpeg"
    />
  </div>
  <br />
  <br />
  <div class="container" style="text-align: justify !important">
    <div class="row">
      <div class="col-md-12">
        <p style="color: white;">
          Pediatric physiotherapy, also known as pediatric physical therapy, is
          a specialized branch of healthcare dedicated to improving the physical
          development, mobility, and overall well-being of infants, children,
          and adolescents. This crucial field focuses on addressing a wide range
          of developmental, musculoskeletal, neurological, and congenital
          conditions that can affect a child's physical abilities. Pediatric
          physiotherapists are highly trained professionals who work closely
          with young patients and their families to assess, diagnose, and create
          personalized treatment plans. These plans often involve a combination
          of exercises, stretches, and therapeutic activities designed to
          enhance a child's strength, balance, coordination, and functional
          independence. Whether it's helping a child with developmental delays
          achieve milestones or assisting a young athlete in recovering from an
          injury, pediatric physiotherapy plays a vital role in promoting the
          health and happiness of children as they grow and develop.
        </p>
      </div>
    </div>
  </div>
</div>
